import { FieldFilter, Filter } from 'module/types/filter-field/filter';
import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SelectedConditions } from '../selected-conditions/selected';

export const BlockSpace = styled(Space)`
  width: 100%;
`;

export const SelectedValues = ({
  selectedCondition,
  showType,
  customOptionTrigger,
}: {
  showType?: boolean;
  selectedCondition: Filter;
  customOptionTrigger?: boolean;
}) => {
  const { type, criteria } = selectedCondition;
  const safeCriteria: FieldFilter[] = (criteria ?? []).filter((criterion) =>
    Boolean(criterion.field)
  );

  return (
    <BlockSpace direction="vertical" size="small">
      {type && showType ? (
        <FormattedMessage
          id="settings.integrations.sf.automation.create.matches.condition"
          values={{
            i: () => (
              <i>
                <b>{type}</b>
              </i>
            ),
          }}
        />
      ) : null}

      {safeCriteria.length ? (
        <SelectedConditions
          criteria={safeCriteria}
          customOptionTrigger={customOptionTrigger}
        />
      ) : null}
    </BlockSpace>
  );
};
